<template>
  <div v-if="!friendsAndFamily">
    <section class="row" id="edit-column-width">
      <b-col sm="12">
        <div class="form-horizontal">
          <h6 style="margin-bottom:4%;" class="section-heading">
            Share Your Wishlist
          </h6>
          <!-- Guest Card Main Section -->
          <div class="form-group form-group-venue text-center">
            <div class="form-group form-group-venue">
              <b-col sm="12">
                <p>
                  Create your own personalised Electronic Guest Card <br />
                  below or order pre-designed physical Guest Cards.
                </p>
              </b-col>
            </div>
            <hr style="width:85%; margin-left:7.5%;" />
            <b-row>
              <b-col sm="12">
                <div class="form-group form-group-venue">
                  <b-row>
                    <b-col sm="12">
                      <h5>Electronic Guest Card</h5>
                    </b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row>
                    <b-col sm="12">
                      <strong>Step One:</strong>

                      <p>
                        Choose from the selection of images below or upload your
                        own
                      </p>
                      <strong>Step Two:</strong>
                      <p>
                        Choose from either the pre-written message or write your
                        own
                      </p>
                      <strong>Step Three:</strong>
                      <p>
                        Click Download to Save as a PDF to share with your
                        guests
                      </p>
                    </b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row align-content="center">
                    <b-col sm="1"></b-col>

                    <b-col sm="10" class="ml-2 mr-2">
                      <b-img
                        class="avatarImg"
                        thumbnail
                        fluid
                        responsive
                        :src="imageSrc"
                        style=";"
                        alt="Selected GuestCard"
                      ></b-img>
                    </b-col>
                    <b-col sm="1"></b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row align-content="center">
                    <b-col sm="3"></b-col>

                    <b-col sm="6" class="ml-2 mr-1">
                      <b-form-group label="" class="form-group input-group pt-2">
                        <b-form-file
                          style="width:80%;"
                          v-model="image"
                          type="file"
                          ref="file"
                          accept="image/*"
                          placeholder="Choose a file or drop it here..."
                          @change="selectedGuestCard('personalImg', imageSrc)"
                          drop-placeholder="Drop file here..."
                        >
                        </b-form-file>
                        <p class="text-center">
                          <small>Maximum upload files size: 500KB</small>
                        </p>
                        <div
                          class="alert alert-danger m-b-0"
                          style="width:75%; margin-left:12.5%;"
                          v-if="imgError"
                        >
                          Image has exceeded maximum limit
                        </div>
                        <div style="text-align:center;">
                          <a
                            data-bs-toggle="modal"
                            style="cursor: pointer;"
                            data-bs-target="#gc_modal"
                            >Choose Another Image
                            <i
                              class="material-icons"
                              style="vertical-align: middle; "
                              >keyboard_arrow_right</i
                            ></a
                          >
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row>
                    <label class="col-sm-2 control-label"></label>
                    <!--  <label v-else for="Time" class="col-sm-3 control-label">Personalised Guest Card Message:</label> -->
                    <b-col sm="8">
                      <p
                        v-if="
                          $store.state.wishlistType === 'wishlist' &&
                            personaliseMessage === 'false'
                        "
                        class="text-center"
                        style="line-height:2em;"
                      >
                        <i
                          class="material-icons"
                          style="transform:rotate(180deg);"
                          >format_quote</i
                        >
                        The most important gift to us is having you share our
                        special day, but should you wish to contribute we have
                        registered with Trailfinders’ Honeymoon Wishlist.<i
                          class="material-icons"
                          >format_quote</i
                        >
                      </p>
                      <p
                        v-else-if="
                          $store.state.wishlistType === 'giftlist' &&
                            personaliseMessage === 'false'
                        "
                        class="text-center"
                        style="line-height:2em;"
                      >
                        <i
                          class="material-icons"
                          style="transform:rotate(180deg);"
                          >format_quote</i
                        >
                        Turn today’s celebration into tomorrow’s adventure.<i
                          class="material-icons"
                          >format_quote</i
                        >
                      </p>
                      <p v-else class="text-center" style="line-height:2em;">
                        <i
                          class="material-icons"
                          style="transform:rotate(180deg);"
                          >format_quote</i
                        >{{ gcMessage
                        }}<i class="material-icons">format_quote</i>
                      </p>
                    </b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row>
                    <label
                      for="personaliseMessage"
                      class="col-sm-2 control-label"
                    ></label>

                    <b-col sm="8">
                      <b-form-checkbox
                        v-model="personaliseMessage"
                        id="personaliseMessage"
                        name="personaliseMessage"
                        value="true"
                        unchecked-value="false"
                        size="sm"
                      >
                        &nbsp; Write your own Guest Card Message?
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="personaliseMessage === 'true'"
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <b-col sm="2">
                      <label for="gcMessage" class="control-label"
                        >Guest Card Message<span class="required">*</span><br />
                        <small>(Max Limit of 120 Characters)</small>
                      </label>
                    </b-col>
                    <b-col sm="8">
                      <textarea
                        rows="2"
                        cols="50"
                        maxlength="120"
                        type="text"
                        class="form-control"
                        id="gcMessage"
                        placeholder="Your Message"
                        v-model="gcMessage"
                      ></textarea>
                      <p
                        v-if="personalMessageRequired"
                        class="alert alert-danger m-b-0"
                      >
                        Required Field<span class="required">*</span>
                      </p>
                    </b-col>
                  </b-row>
                </div>

                <div class="form-group form-group-venue">
                  <b-row>
                    <b-col sm="1"></b-col>
                    <b-col sm="10">
                      <button
                        v-if="$store.state.wishlistType === 'giftlist'"
                        style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:35%;"
                        class="btn btn-primary mt-2 float-center"
                        @click="downloadSection('gc_electronic_preview')"
                      >
                        Create & Save
                      </button>
                      <button
                        v-else
                        style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:35%;"
                        class="btn btn-primary mt-2 float-center"
                        @click="downloadSection('gc_electronic_preview')"
                      >
                        Create & Save
                      </button>
                    </b-col>
                  </b-row>
                </div>

                <hr style="width:85%; margin-left:7.5%;" />

                <div class="form-group form-group-venue">
                  <b-row>
                    <label for="" class="col-sm-2 control-label"></label>
                    <b-col sm="8">
                      <h5>Guest Card</h5>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <label for="" class="col-sm-2 control-label"></label>
                    <b-col sm="8">
                      <h6>
                        Please specify how you would like your name(s) to appear
                        on the guest cards. E.g. Catherine Lee and Thomas Brown
                        or Katie Lee and Tom Brown..
                      </h6>
                    </b-col>
                  </b-row>
                </div>

                <!-- v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  " -->
                <div class="form-group form-group-venue">
                  <b-row>
                    <label for="per1Title" class="col-sm-2 control-label"
                      >{{ $store.state.user.person_01.title
                      }}<span class="required">*</span></label
                    >
                    <b-col sm="4">
                      <input
                        type="text"
                        class="form-control"
                        id="per1Name"
                        placeholder="FirstName"
                        v-model="$store.state.user.person_01.first_name"
                      />
                    </b-col>
                    <b-col sm="4">
                      <input
                        disabled
                        type="text"
                        class="form-control"
                        id="per1LastName"
                        placeholder="LastName"
                        v-model="$store.state.user.person_01.last_name"
                      />
                    </b-col>
                  </b-row>
                </div>

                <!-- v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  " -->
                <div class="form-group form-group-venue">
                  <b-row>
                    <label for="per2Title" class="col-sm-2 control-label"
                      >{{ $store.state.user.person_02.title
                      }}<span class="required">*</span></label
                    >
                    <b-col sm="4">
                      <input
                        type="text"
                        class="form-control"
                        id="per2Name"
                        placeholder="FirstName"
                        v-model="$store.state.user.person_02.first_name"
                      />
                    </b-col>
                    <b-col sm="4">
                      <input
                        disabled
                        type="text"
                        class="form-control"
                        id="per2LastName"
                        placeholder="LastName"
                        v-model="$store.state.user.person_02.last_name"
                      />
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <label for="Quantity" class="col-sm-2 control-label"
                      >How many cards would you like?<span class="required"
                        >*</span
                      ></label
                    >
                    <b-col sm="8">
                      <input
                        type="number"
                        min="0"
                        max="10000"
                        class="form-control"
                        placeholder="Amount"
                        v-model="$store.state.user.gift_cards.amount"
                      />
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <label for="" class="col-sm-2 control-label"></label>
                    <b-col sm="8">
                      <p>
                        Please select the amount of cards you require. Should
                        you need more than 100, please contact our Honeymoons
                        Team on
                        <strong
                          ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '020 7368 1404' ? 'text_link' : null">{{ telNo }}</a></strong
                        >
                        who will process your order for an admin charge of
                        {{ priceCharge }}
                      </p>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <label for="" class="col-sm-2 control-label"></label>
                    <b-col sm="8">
                      <button
                        v-if="$store.state.wishlistType === 'giftlist'"
                        style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:35%;"
                        class="btn btn-primary mt-2 float-center"
                        @click="onSubmit"
                      >
                        Submit
                      </button>
                      <button
                        v-else
                        @click="onSubmit"
                        style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:35%;"
                        class="btn btn-primary mt-2 float-center"
                      >
                        Submit
                      </button>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      !$store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <label for="" class="col-sm-3 control-label"></label>
                    <b-col sm="8">
                      <div class="error-box">
                        <p
                          class="bg-success"
                          style="padding: 15px"
                          v-show="showSuccess"
                        >
                          Thank you. Your card order will be processed today.
                        </p>

                        <p
                          class="bg-danger"
                          style="padding: 15px"
                          v-show="showError"
                        >
                          There was a problem ordering your cards. please call
                          us on
                          <strong
                            ><a
                              style="text-decoration:none; color:black;"
                              :href="`tel:${telNo}`"
                              :data-ga4-label="telNo === '020 7368 1404' ? 'wishlist_admin' : null"
                              :data-ga4-category="telNo === '020 7368 1404' ? 'text_link' : null"
                              >{{ telNo }}</a
                            ></strong
                          >.<br />
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    $store.state.user.gift_cards &&
                      $store.state.user.gift_cards.ordered
                  "
                  class="form-group form-group-venue"
                >
                  <b-row>
                    <b-col sm="1"></b-col>
                    <b-col sm="10">
                      <div class="well" role="alert">
                        <p>
                          <small
                            >Your card order for
                            {{ $store.state.user.gift_cards.amount }} cards has
                            been processed.<br /><br />
                          </small>
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- Guest Card PDF Template -->
          <div
            style="display:none;"
            class="section printable showPrint"
            id="gc_preview"
          >
            <div id="contrib-print">
              <div>
                <img
                  style=" width: 100%;"
                  :src="imageSrc"
                  class="banner"
                  alt="wishlist Banner"
                />
                <b-row align-content="center">
                  <b-col sm="2"></b-col>
                  <b-col sm="8">
                    <img
                      v-if="$store.state.wishlistType === 'wishlist'"
                      style="width:40%; margin-left:30%; padding-top:10%; padding-bottom:2%;"
                      :src="
                        `https://www.trailfinders${ref}/graphics/weddings/logo-tf-wishlist.png`
                      "
                    />
                    <img
                      v-else
                      style="width:40%; margin-left:30%; padding-top:10%; padding-bottom:2%;"
                      :src="
                        `https://www.trailfinders${ref}/graphics/giftlist/logo-tf-giftlist.png`
                      "
                    />
                  </b-col>
                </b-row>

                <b-row align-content="center">
                  <b-col sm="2"></b-col>
                  <b-col sm="8">
                    <p
                      v-if="
                        $store.state.wishlistType === 'wishlist' &&
                          gcMessage === ''
                      "
                      class="text-center"
                    >
                      The most important gift to us is having you share our
                      special day, but should you wish to contribute we have
                      registered with Trailfinders’ Honeymoon Wishlist.
                    </p>
                    <h4
                      v-else-if="
                        $store.state.wishlistType === 'giftlist' &&
                          gcMessage === ''
                      "
                      class="text-center"
                    >
                      Turn today’s celebration into tomorrow’s adventure.
                    </h4>
                    <p v-else class="text-center">{{ gcMessage }}</p>
                  </b-col>
                </b-row>

                <b-col sm="2"></b-col>
                <b-col sm="8">
                  <hr style="width:85%; margin-left:7.5%;" />

                  <b-row align-content="center">
                    <p
                      class="text-center ml-0 pb-0"
                      style="margin-bottom:0px; "
                    >
                      <strong>{{ $store.state.user.couple_title }}</strong>
                    </p>
                  </b-row>

                  <hr style="width:85%; margin-left:7.5%;" />

                  <p class="text-center ml-0 pb-0" style="margin-bottom:2px; ">
                    Wishlist Reference:
                    <strong>{{ $store.state.user.reference }}</strong>
                  </p>
                  <p class="text-center ml-0 pb-0 " style="margin-bottom:0px;">
                    Closing Date:
                    <strong>{{
                      $store.state.user.contributions_closing.pretty
                    }}</strong>
                  </p>
                  <hr style="width:85%; margin-left:7.5%;" />
                </b-col>

                <b-col sm="12">
                  <b-row align-content="center">
                    <p class="text-center ml-3 pb-0 mb-0">
                      To contribute visit
                      <strong
                        ><a target="_blank" href="/wishlist"
                          >trailfinders{{ ref }}/wishlist</a
                        ></strong
                      >
                      or call
                      <strong
                        ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '020 7368 1404' ? 'text_link' : null">{{ telNo }}</a></strong
                      >
                    </p>
                  </b-row>
                </b-col>
              </div>
            </div>
          </div>

          <!-- Guest Card Electronic PDF Save/Download  Modal-->
          <div
            v-show="gc_preview"
            class="modal-dialog modal-lg"
            role="document"
          >
            <div class="modal-content" id="gc_electronic_preview">
              <div class="modal-body">
                <b-row>
                  <b-col sm="12">
                    <b-row align-content="center">
                      <b-img
                        style="width:100%; max-width:1024px; max-height:500px;"
                        class="pb-0 mb-0"
                        fluid
                        :src="imageSrc"
                      ></b-img>
                    </b-row>
                  </b-col>
                  <!-- <b-col sm="12"> -->
                  <b-row align-content="center">
                    <!-- <b-col sm=2></b-col> -->
                    <b-col sm="12">
                      <img
                        v-if="$store.state.wishlistType === 'wishlist'"
                        style="width:65%; margin-left:17.5%; padding-top:5%; padding-bottom:0%;"
                        :src="
                          `https://www.trailfinders${ref}/graphics/weddings/logo-tf-wishlist.png`
                        "
                      />
                      <img
                        v-else
                        style="width:65%; margin-left:17.5%; padding-top:15%; padding-bottom:5%;"
                        :src="
                          `https://www.trailfinders${ref}/graphics/giftlist/logo-tf-giftlist.png`
                        "
                      />
                    </b-col>
                  </b-row>

                  <b-row align-content="center">
                    <b-col sm="2"></b-col>
                    <b-col sm="8">
                      <p
                        v-if="
                          $store.state.wishlistType === 'wishlist' &&
                            gcMessage === ''
                        "
                        class="text-center"
                      >
                        The most important gift to us is having you share our
                        special day, but should you wish to contribute we have
                        registered with Trailfinders’ Honeymoon Wishlist.
                      </p>
                      <h4
                        v-else-if="
                          $store.state.wishlistType === 'giftlist' &&
                            gcMessage === ''
                        "
                        class="text-center"
                      >
                        Turn today’s celebration into tomorrow’s adventure.
                      </h4>
                      <p v-else class="text-center">{{ gcMessage }}</p>
                    </b-col>
                  </b-row>
                  <b-col sm="2"></b-col>
                  <b-col sm="8">
                    <hr style="width:85%; margin-left:7.5%;" />

                    <b-row align-content="center">
                      <p
                        class="text-center ml-0 pb-0"
                        style="margin-bottom:0px; "
                      >
                        <strong>{{ $store.state.user.couple_title }}</strong>
                      </p>
                    </b-row>

                    <hr style="width:85%; margin-left:7.5%;" />

                    <p
                      class="text-center ml-0 pb-0"
                      style="margin-bottom:2px; "
                    >
                      Wishlist Reference:
                      <strong>{{ $store.state.user.reference }}</strong>
                    </p>
                    <p
                      class="text-center ml-0 pb-0 "
                      style="margin-bottom:0px;"
                    >
                      Closing Date:
                      <strong>{{
                        $store.state.user.contributions_closing.pretty
                      }}</strong>
                    </p>
                    <hr style="width:85%; margin-left:7.5%;" />
                  </b-col>

                  <b-col sm="12">
                    <b-row align-content="center">
                      <p class="text-center ml-3 pb-0 mb-0">
                        To contribute visit
                        <strong
                          ><a target="_blank" href="/wishlist"
                            >trailfinders{{ ref }}/wishlist</a
                          ></strong
                        >
                        or call
                        <strong
                          ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '020 7368 1404' ? 'text_link' : null">{{ telNo }}</a></strong
                        >
                      </p>
                    </b-row>
                  </b-col>
                  <!-- </b-col> -->
                </b-row>
              </div>
            </div>
          </div>
          <!-- Guest Card Image Options Modal -->
          <div
            class="modal"
            id="gc_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="preview"
            aria-hidden="true"
            size="lg"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content" id="gc_options">
                <div class="modal-body">
                  <section class="row form-group">
                    <div class="col-xs-12 col-md-12">
                      <div id="BrochureFanPanel">
                        <div class="panel panel-grey panel-cta m-b-0">
                          <div class="modal-header text-center">
                            <button
                              type="button"
                              class="btn-close float-end"
                              style=" margin: 0;"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            > 
                            </button>
                            <div class="text-center pt-3">
                              <h3>Guest Card Image Options</h3>
                            </div>
                          </div>
                          <div class="panel-body">
                            <section class="brochure-display">
                              <div class="row">
                                <div
                                  v-for="img in guestCardDesigns"
                                  :key="img.cardDesign"
                                  style="width: 33%"
                                >
                                  <img
                                    :src="img.url"
                                    alt="Gift Card"
                                    style="width: 100%; border-radius: 12%;"
                                    v-on:click="
                                      selectedGuestCard(
                                        img.cardDesign,
                                        img.urlLarge
                                      )
                                    "
                                    class="pb-3 pl-2 pr-2"
                                    :class="{
                                      chosenCard: card_design === img.cardDesign
                                    }"
                                  />
                                </div>
                              </div>
                            </section>
                          </div>
                          <div class="modal-footer pt-0 mt-0">
                            <button
                              type="button"
                              class="btn btn-secondary btn-lg"
                              data-bs-dismiss="modal"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </section>
  </div>
</template>

<script>
import { orderGuestcards, updateWishlist } from "../../services/api";
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      card_design: "",
      guestCardDesigns: [
        {
          cardDesign: "a",
          url:
            "https://cdn.trailfinders.com/images/1502731/AdobeStock_66358333.jpeg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1502731/AdobeStock_66358333.jpeg?width=500"
        },
        {
          cardDesign: "b",
          url:
            "https://cdn.trailfinders.com/images/2226222/28470173_l.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2226222/28470173_l.jpg?width=500"
        },
        {
          cardDesign: "c",
          url:
            "https://cdn.trailfinders.com/images/1540878/Depositphotos_14443483_original.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1540878/Depositphotos_14443483_original.jpg?width=500"
        },
        {
          cardDesign: "d",
          url:
            "https://cdn.trailfinders.com/images/2659761/Depositphotos_8613539_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2659761/Depositphotos_8613539_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "e",
          url:
            "https://cdn.trailfinders.com/images/2808697/CC3YDE%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2808697/CC3YDE%20copy.jpg?width=500"
        },
        {
          cardDesign: "f",
          url:
            "https://cdn.trailfinders.com/images/2808853/iStock-1021697344%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2808853/iStock-1021697344%20copy.jpg?width=500"
        },
        {
          cardDesign: "g",
          url:
            "https://cdn.trailfinders.com/images/2261628/iStock-694429000.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2261628/iStock-694429000.jpg?width=500"
        },
        {
          cardDesign: "h",
          url:
            "https://cdn.trailfinders.com/images/2614240/AWL_KEN8986AW.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2614240/AWL_KEN8986AW.jpg?width=500"
        },
        {
          cardDesign: "i",
          url:
            "https://cdn.trailfinders.com/images/2711224/Depositphotos_190793980_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2711224/Depositphotos_190793980_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "j",
          url:
            "https://cdn.trailfinders.com/images/2310049/KY52M8.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2310049/KY52M8.jpg?width=500"
        },
        {
          cardDesign: "k",
          url:
            "https://cdn.trailfinders.com/images/2641471/iStock-892407318%20EDITED.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2641471/iStock-892407318%20EDITED.jpg?width=500"
        },
        {
          cardDesign: "l",
          url:
            "https://cdn.trailfinders.com/images/2224868/Depositphotos_138170998_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2224868/Depositphotos_138170998_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "m",
          url:
            "https://cdn.trailfinders.com/images/1849074/Depositphotos_6536858_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1849074/Depositphotos_6536858_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "n",
          url:
            "https://cdn.trailfinders.com/images/1811433/Depositphotos_135617220_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1811433/Depositphotos_135617220_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "o",
          url:
            "https://cdn.trailfinders.com/images/2158118/Depositphotos_182896130_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2158118/Depositphotos_182896130_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "p",
          url:
            "https://cdn.trailfinders.com/images/2814604/TCPB0J%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2814604/TCPB0J%20copy.jpg?width=500"
        },
        {
          cardDesign: "q",
          url:
            "https://cdn.trailfinders.com/images/2705938/artem-beliaikin-v6kii3H5CcU-unsplash.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2705938/artem-beliaikin-v6kii3H5CcU-unsplash.jpg?width=500"
        },
        {
          cardDesign: "r",
          url:
            "https://cdn.trailfinders.com/images/1928235/champagne_glasses.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1928235/champagne_glasses.jpg?width=500"
        },
        {
          cardDesign: "s",
          url:
            "https://cdn.trailfinders.com/images/2158048/Depositphotos_140886176_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2158048/Depositphotos_140886176_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "t",
          url:
            "https://cdn.trailfinders.com/images/2833729/MCB%20Wilhelm%20Gunkel.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2833729/MCB%20Wilhelm%20Gunkel.jpg?width=500"
        },
        {
          cardDesign: "u",
          url:
            "https://cdn.trailfinders.com/images/1896994/courtney-hedger-336844-unsplash.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1896994/courtney-hedger-336844-unsplash.jpg?width=500"
        }
      ],
      date: "",
      friendsAndFamily: null,
      personaliseMessage: "false",
      isForMe: "",
      showSuccess: false,
      showError: false,
      priceCharge: "",
      telNo: null,
      image: null,
      imgError: false,
      imageSrc: "",
      arr: [],
      isIe: false,
      ref: ".com",
      personalMessageRequired: false,
      gc_preview: false,
      gcMessage: "",
      welcome_message: "",
      numberOfFields: 0,
      item: {
        name: null,
        url: null
      },
      slide: 0
    };
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgError = false;
              if (
                this.$refs.file.files[0] &&
                this.$refs.file.files[0].size < 350 * 600
              ) {
                this.imageSrc = value;
              } else {
                this.imgError = true;
              }
            })
            .catch(() => {
              this.imageSrc = {};
            });
        } else {
          this.imageSrc = {};
        }
      }
    }
  },
  methods: {
    radioChange(value) {
      this.$store.state.user.show_honeymoon_itinerary = value;
      this.$store.dispatch("setUserAction", this.$store.state.user);
      return value;
    },
    // download section
    downloadSection(_elID) {
      this.personalMessageRequired = false;
      if (this.gcMessage === "" && this.personaliseMessage === "true") {
        this.personalMessageRequired = true;
      } else {
        this.gc_preview = false;
        var prtContent = document.getElementById(_elID);
        var WinDownload = window.open(
          "",
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
        if (this.ref === ".ie") {
          WinDownload.document.write(
            '<link rel="stylesheet" href="https://www.trailfinders.ie/codesource/css/tf-core.min.css?&v=6">'
          );
        } else {
          WinDownload.document.write(
            '<link rel="stylesheet" href="https://www.trailfinders.com/codesource/css/tf-core.min.css?&v=6">'
          );
        }
        WinDownload.document.write(prtContent.innerHTML);
        WinDownload.document.documentElement.className += "windownload";
        this.onSave()
        setTimeout(function() {
          WinDownload.print();
        }, 500);
      }
    },

    formatMessage(value) {
      this.$store.state.user.welcome_message = `<p>` + value + `</p>`;
      this.$store.dispatch("setUserAction", this.$store.state.user);
      return value;
    },

    onClicker(event) {
      if (event === "plus" && this.$store.state.user.where_to_stay.length < 4) {
        this.arr.push({ name: this.item.name, url: this.item.url });
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      } else {
        this.arr.pop();
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      }
    },

    selectedGuestCard(img, src) {
      this.imgError = false;
      this.imageSrc = src;
      this.card_design = img;
    },

    async onSave() {
      this.showSuccess = false;
      this.showError = false;
      this.$store.state.user.gift_cards.gcMessage = this.gcMessage;
      this.$store.state.user.gift_cards.showGcMessage = this.personaliseMessage;
      let res = await updateWishlist(
        this.$store.state.wishlistType,
        this.$store.state.user._id,
        this.$store.state.user
      );
      if (res.error) {
        this.showError = true;
      } else {
        this.showSuccess = true;
      }
    },
    async onSubmit() {
      this.showSuccess = false;
      this.showError = false;
      this.$store.state.user.gift_cards.person_01 = {};
      this.$store.state.user.gift_cards.person_02 = {};
      this.$store.state.user.gift_cards.person_01.first_name = this.$store.state.user.person_01.first_name;
      this.$store.state.user.gift_cards.person_01.last_name = this.$store.state.user.person_01.last_name;
      this.$store.state.user.gift_cards.person_02.first_name = this.$store.state.user.person_02.first_name;
      this.$store.state.user.gift_cards.person_02.last_name = this.$store.state.user.person_02.last_name;
      this.$store.state.user.gift_cards.order_date = Date.now();

      await this.$store.dispatch("setUserAction", this.$store.state.user);
      let res = await orderGuestcards(
        this.$store.state.user._id,
        this.$store.state.user
      );
      if (res.error) {
        this.showError = true;
      } else {
        this.showSuccess = true;
        this.$store.dispatch("setUserAction", res.data);
      }
    }
  },
  mounted() {
    if (this.$route.params.wishlistType === "friends-and-family") {
      this.friendsAndFamily = true;
    }

    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true;
      this.ref = ".ie";
      this.priceCharge = "€15";
    } else {
      this.isIe = false;
      this.ref = ".com";
      this.priceCharge = "£15";
    }
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.telNo = "01 881 4990";
    } else if (this.$store.state.wishlistType === "giftlist") {
      this.telNo = "020 7408 9008";
    } else {
     // this.telNo = "020 7084 6512";
      this.telNo = "020 7368 1404";
    }
    if (this.$store.state.user.gift_cards) {
      this.gcMessage = this.$store.state.user.gift_cards.gcMessage;
      this.personaliseMessage =
        this.$store.state.user.gift_cards.showGcMessage;
    } else {
      this.gcMessage = "";
      this.personaliseMessage = "false";
    }
    this.imageSrc = this.$store.state.user.couple_image_large;
    this.meta.loaded = true;
    this.arr = this.$store.state.user.where_to_stay;
    this.welcome_message = this.$store.state.user.welcome_message.replace(
      /<[^>]+>/g,
      ""
    );
    this.date = Date.now();
  }
};
</script>
<style lang="scss">
@media print {
  .pagebreak {
    page-break-before: always;
  } /* page-break-after works, as well */
}
</style>
<style>
.express-vue-temp .modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1080;
  display: none;
  width: 100%;
  height: 100%;
  overflow: scroll;
  outline: 0;
}
.designs {
  border-radius: 15%;
  padding-bottom: 20px;
}
.designs:hover {
  cursor: pointer;
}
.chosenCard {
  opacity: 0.5;
}
.express-vue-temp
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: orange;
  color: white;
}
.checkbox label,
.radio label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 0px;
  margin: 0;
  line-height: 30px;
  min-height: 30px;
  font-weight: 400;
  cursor: pointer;
}
.checkbox label,
.radio label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 0px !important;
  margin: 0;
  line-height: 30px;
  min-height: 30px;
  font-weight: 400;
  cursor: pointer;
}
#gc_modal .btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
#gc_modal .btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
</style>
